import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../api/axiosInstance";
import { setOtherInfo } from "../../slice/userSlice";

export const qrCode = createAsyncThunk(
  "user/qrCode",
  async (credentials, thunkAPI) => {
    try {
      const  response = await axiosInstance.get("/qrcode/generate");
      return response.data.image;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
